import React from 'react'
import { Carousel } from 'react-bootstrap';
import './registration.css';


import CCourseimg2 from '../../assets/courseheaderimg1.png';
import CCourseimg3 from '../../assets/courseheaderimg2.png';
import CCourseimg4 from '../../assets/courseheaderimg3.png';


function FellowshipCourse() {
  
  return (
 
    <div className='diploma-in-audiology'>

          <div className="banner-diploma">
        {/* Auto Sliding Banner */}
        <Carousel className="mb-5">
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={CCourseimg4}
              alt="First slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg3}
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg2}
              alt="Third slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>


  <div className="diploma-optometry-container">
  <h1 className="fellowship-title">Fellowship Courses</h1>
  
             <button
                className="btn arrow-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#courseDetails"
                aria-expanded="false"
                aria-controls="courseDetails"
                >
                Fellowship in Clinical Optometry
                <span className="arrow-icon">&#xf0d7;</span>
              </button>

  {/* Collapsible Content */}
  <div className="collapse" id="courseDetails">
    <section className="section">
      <h2 className="diploma-title">Fellowship in Clinical Optometry</h2>
      <p>Specific topics covered in the journal include: Theoretical and applied optics, Delivery of patient care in optometry practice, Refraction and correction of errors, Screening and preventative aspects of eye disease, Extended clinical roles for optometrists including shared care and provision of medications, Teaching and training optometrists, International aspects of optometry, Business practice, Patient adherence, quality of life, satisfaction, Health economic evaluations.</p>
    </section>

    <section className="section">
      <h2>Eligibility</h2>
      <p>BSc / Diploma in Optometry</p>
    </section>

    <section className="section">
      <h2>Duration</h2>
      <p>Duration    : 6 months</p>
      <p>Admission   : Jan and June</p>
    </section>

    <section className="section">
      <h2>For a Batch</h2>
      <p> 20 Seats</p>
    </section>

    <section className="section">
      <h2>About Course</h2>
      <p>
        Clinical Optometry is a science, which deals with the structure, function and working of the human eye. Popularly known as Optometry, this health care profession is concerned with examination, diagnosis and treatment of eyes, specially related to visual, optical symptoms, refractive errors and their correction, using lenses and other optical aids. The scope for optometric practice in India and abroad is great and unlimited. It is a dynamic and challenging career which could achieve personal growth, community respect and offers job flexibility, financial success and unlimited opportunities..
        Clinical optometry is, perhaps, the newest sub specialty of Optometry.
        While Optometry has an obvious and major role to play in the measurement and optimization of functional vision and in the treatment of many vision disorders in all population, Optometry is also responsible for building the evidence base for the treatments.
      </p>
    </section>

    <section className="section">
      <h2>Objectives</h2>
      <p>
        Specific topics covered in the journal include: Theoretical and applied optics, Delivery of patient care in optometry practice, 
        Refraction and correction of errors, Screening and preventative aspects of eye disease, Extended clinical roles for optometrists including shared care and provision of medications, 
        Teaching and training optometrists, International aspects of optometry, Business practice, Patient adherence, quality of life, satisfaction, Health economic evaluations.
      </p>
    </section>

    <section className="section">
      <div className="course-outline-container">
        <h1>Course Outline</h1>
        <table className="course-outline-table">
          <thead>
            <tr>
              <th>Paper</th>
              <th>Units</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PAPER I: REFRACTION CLINIC</td>
              <td>
                <ul>
                  <li>UNIT I: SUBJECTIVE & OBJECTIVE REFRACTION MODALITIES</li>
                  <li>UNIT II: ANTERIOR SEGMENT EVALUATIONS</li>
                  <li>UNIT III: POSTERIOR SEGMENT EVALUATIONS</li>
                  <li>UNIT IV: ROLE OF OPTOMETRIST IN REFRACTIVE SURGERIES</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>PAPER II: CONTACT LENS & LOW VISION CLINIC</td>
              <td>
                <ul>
                  <li>UNIT I: CLASSIFICATION, FITTING AND EVALUATIONS OF CONTACT LENS</li>
                  <li>UNIT II: DISPENSING AND PATIENT SELECTION FOR CONTACT LENS</li>
                  <li>UNIT III: CLINICAL EXAMINATION & OPTICS OF LOW VISION</li>
                  <li>UNIT IV: MANAGEMENT OF LOW VISION & TECHNOLOGY APPLICATION IN LVR</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>PAPER III: STRABISMUS & VISION THERAPY CLINIC</td>
              <td>
                <ul>
                  <li>UNIT I: CLASSIFICATION OF STRABISMUS</li>
                  <li>UNIT II: DETECTION OF SQUINT</li>
                  <li>UNIT III: MANAGEMENT OF SQUINT</li>
                  <li>UNIT IV: VISION THERAPY IN STRABISMUS</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>PAPER IV: GERIATRIC & PEDIATRIC CLINIC</td>
              <td>
                <ul>
                  <li>UNIT I: ASSESSMENT OF OCULAR HEALTH AND COMMON DEFECT IN OLD EYE</li>
                  <li>UNIT II: ASSESSMENT OF OCULAR HEALTH AND COMMON DEFECT IN CHILDHOOD</li>
                  <li>UNIT III: ASSESSMENT OF BINOCULAR VISION AND ACCOMMODATION</li>
                  <li>UNIT IV: DISPENSING FOR GERIATRICS & PEDIATRICS</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div> 
    </section>
  </div>
</div>



    <div className="diploma-optometry-container">
                <button
                className="btn arrow-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#courseDetailsSecond"
                aria-expanded="false"
                aria-controls="courseDetails"
               >
                Fellowship in Low Vision Rehabilitation
                <span className="arrow-icon">&#xf0d7;</span>
              </button>

  {/* Collapsible Content */}
  <div className="collapse" id="courseDetailsSecond">
          <section className="section">
          <h2 className="diploma-title">Fellowship in Low Vision Rehabilitation</h2>
          <p>Low vision rehabilitation should be considered part of the continuum of eye care. This One year fellowship program aims to train Optometrists to become experts in low vision rehabilitation.</p>
          </section>
          <section className="section">
            <h2>Eligibility</h2>
            <p>BSc / Diploma in Optometry</p>
          </section>
          <section className="section">
            <h2>Duration</h2>
            <p>Duration    : 06 months</p>
            <p>Admission   : Jan and June</p>
          </section>
          <section className="section">
            <h2>For a Batch</h2>
            <p> 20 Seats</p>
          </section>
          <section className="section">
            <h2>About this Course</h2>
            <p>
            Low vision rehabilitation should be considered part of the continuum of eye care that includes refractive, medical and surgical eye care, which begins at birth and carries forward throughout life. The goal of vision rehabilitation is to maximize an individual’s functional vision. In so doing, the individual’s functional potential will be enhanced, resulting in increase independence and improved quality of life.
            Majority of patients with low vision can be helped to function at a higher level with the use of low vision devices. Management of a Low-vision patient does not end with prescribing Low vision device alone. It involves a coordinated effort on the part of the practitioner, patient and his / her family members to recognize the patient’s limitations, and help him / her choose devices that will satisfy the patient’s visual needs. It is also a multi-disciplinary approach where a low-vision practitioner has to work in tandem with other professionals like Ophthalmologists and Dispensing Opticians.
            The main objective of this program is to give the optometrist a basic understanding of low vision and to assess and examine the low vision patients. Prescribing low vision devices for better visual function. It is important to assist in counseling and rehabilitating the low vision patient.
            The course is divided into two parts: Online Course and Hands on training. After successful completion of the online course and Hands on training, candidates must complete an online assessment test for each unit, comprising multiple choices and an onsite examination of the subject at the end of the academic year. A 60% pass rate is required. 
            </p>
          </section>
          <div className="course-outline-container">
          <h1>Course Outline</h1>
          <table className="course-outline-table">
            <thead>
              <tr>
                <th>No :</th>
                <th>Topic</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Introduction to Low Vision</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Causes & Symptoms of Low Vision</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Clinical Assessment of Low Vision</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Magnification</td>
              </tr>
              <tr>
                <td>5</td>
                <td>Optical Low Vision Devices</td>
              </tr>
              <tr>
                <td>6</td>
                <td>Non-optical Low Vision Devices</td>
              </tr>
              <tr>
                <td>7</td>
                <td>Orientation & Mobility</td>
              </tr>
              <tr>
                <td>8</td>
                <td>Using Functional and Residual Vision to Achieve Independent Living</td>
              </tr>
              <tr>
                <td>9</td>
                <td>Setting Up a Low Vision Program</td>
              </tr>
              <tr>
                <td>10</td>
                <td>Environmental Modification</td>
              </tr>
              <tr>
                <td>11</td>
                <td>Lighting Glare and Low Vision</td>
              </tr>
              <tr>
                <td>12</td>
                <td>Prescribing for Glaucoma and RP</td>
              </tr>
              <tr>
                <td>13</td>
                <td>Training in the Use of Low Vision Devices</td>
              </tr>
              <tr>
                <td>14</td>
                <td>Early Intervention in Low Vision</td>
              </tr>
              <tr>
                <td>15</td>
                <td>Reading Speed and LV Assessment</td>
              </tr>
              <tr>
                <td>16</td>
                <td>Low Vision Devices for Children</td>
              </tr>
              <tr>
                <td>17</td>
                <td>Prescribing for Paediatric Aphakia</td>
              </tr>
              <tr>
                <td>18</td>
                <td>Management of Children with Multiple Disabilities</td>
              </tr>
              <tr>
                <td>19</td>
                <td>Functional Vision Assessment</td>
              </tr>
              <tr>
                <td>20</td>
                <td>Functional Vision Assessment for Children with Low Vision</td>
              </tr>
              <tr>
                <td>21</td>
                <td>Scoring of Functional Vision</td>
              </tr>
              <tr>
                <td>22</td>
                <td>Perspective of a Low Vision Patient</td>
              </tr>
              <tr>
                <td>23</td>
                <td>Case Studies</td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
    </div>


    <div className="diploma-optometry-container">
             
              <button
                className="btn arrow-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#courseDetailsThird"
                aria-expanded="false"
                aria-controls="courseDetails"
              >
                Fellowship in Pediatric Optometry
                <span className="arrow-icon">&#xf0d7;</span>
              </button>

  {/* Collapsible Content */}
  <div className="collapse" id="courseDetailsThird">
          <section className="section">
          <h2 className="diploma-title">Fellowship in Pediatric Optometry</h2>
          <p>Healthy eyes and vision are especially important for infants and children. The visual skills developed during early life set the foundation for future learning. Early detection of vision problems is critical to helping young people achieve their full potential. Pediatric optometry deals with eye issues related to children. Examination of children for vision and its related may be impossible for an ordinary optometrist in a single visit to complete all the tests. An optometrist specialized in Pediatric Optometry can perform well there.</p>
          </section>

          <section className="section">
            <h2>Eligibility</h2>
            <p>BSc / Diploma in Optometry</p>
          </section>

          <section className="section">
            <h2>Duration</h2>
            <p>Duration    : 06 months</p>
            <p>Admission   : Jan and June</p>
          </section>
          <section className="section">
            <h2>For a Batch</h2>
            <p> 20 Seats</p>
          </section>
      
          <section className="section">
            <h2>About this Course</h2>
            <p>
            Although perfect eyesight should come with young age, some children, unfortunately, can not see very well. Fortunately, they can see a Pediatric Optometrist for help. A Pediatric Optometrist is an Optometrist, who specializes in juvenile patients.
            When you are a Pediatric Optometrist, your job is to diagnose and treat vision problems, just like a regular Optometrist. Those problems include nearsightedness, farsightedness, cataracts, astigmatism, and amblyopia or “lazy eye.” Like a Pediatrician to a Physician, the only major difference is your patients, most of whom are children.
            That means you might work for a school , testing students’ vision at school, although you most likely work for a private optometry practice or clinic. Regardless, your main responsibility is diagnostic vision exams, which have several components.
            The first is physically examining the eye for signs of damage, such as squinting, redness, or swelling. The second is testing pupil functioning with a penlight. Next are a series of checks that test eye alignment, color vision, peripheral vision, and vision depth. Finally is the standard Snellen test, which tests visual acuity with an alphabetic chart.
            The course is divided into two parts: Online Course and Hands on training.
            After successful completion of the online course and Hands on training, candidates must complete an online assessment test for each unit, comprising multiple choices and an onsite examination of the subject at the end of the academic year. A 60% pass rate is required.
            </p>
          </section>

          <div className="course-outline-container">
              <h1>Course Outline</h1>
              <table className="course-outline-table">
                <thead>
                  <tr>
                    <th>No :</th>
                    <th>Topic</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Paediatric Testing: Visual Function</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Paediatric Testing: Refraction and Accommodation</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Visual Acuity</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Effect of Abnormal Visual Experience on Visual Development</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Stereopsis</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Accommodation</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Colour Vision</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Normal Refractive Development</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Refractive Development and Evidence-Based Prescribing</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Paediatric Ocular Pathology</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Case Studies</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Dispensing for Children</td>
                  </tr>
                </tbody>
              </table>
            </div>
    </div>
    </div>




    <div className="diploma-optometry-container">
              {/* Dropdown Button-Fellowship in Clinical Optometry */}
              <button
                className="btn arrow-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#courseDetailsFourth"
                aria-expanded="false"
                aria-controls="courseDetails"
              >
                Fellowship in Spectacle Dispensing
                <span className="arrow-icon">&#xf0d7;</span>
              </button>



  {/* Collapsible Content */}
  <div className="collapse" id="courseDetailsFourth">
          <section className="section">
          <h2 className="diploma-title">Fellowship in Spectacle Dispensing</h2>
          <p>Optical industry is one of the fastest growing industries in the present scenario. When Optometrist have opportunities to get specialized in this particular field they will have increased opportunities to work in leading optical outlets, branded lens companies , work in hospital based optical outlets and will be qualified to run a optical shop.</p>
          </section>

          <section className="section">
            <h2>Eligibility</h2>
            <p>Fellowship is open to the optometrists who are completed 4 year Degree or 2 year Diploma in Optometry</p>
          </section>

          <section className="section">
            <h2>Duration</h2>
            <p>Duration    : 01 Year</p>
            <p>Admission   : Jan and June</p>
          </section>
          <section className="section">
            <h2>For a Batch</h2>
            <p> 10 Seats</p>
          </section>
      
          <section className="section">
            <h2>About this Course</h2>
            <p>
            Optometrists advises on, fits and supplies the most appropriate spectacles after taking account of each patient’s visual, lifestyle and vocational needs.They also play an important role in advising and dispensing low vision aids to those who are partially sighted as well as advising on and dispensing to children where appropriate.
            Their specialist skills include professional advice on lenses for night driving, UV protection, prescription sunglasses, spectacles for VDU use, sports and safety eyewear
            Dispensing spectacles to children, to the visually impaired, or dispensing of contact lenses can only be undertaken by, or carried out under supervision of optometrists
            The course is divided into two parts: Online Course and Hands on training.
            After successful completion of the online course and Hands on training, candidates must complete an online assessment test for each unit, comprising multiple choices and an onsite examination of the subject at the end of the academic year. A 75% pass rate is required.
            </p>
          </section>

     
        <section className="section">
        <h2>Objectives</h2>
        <p>
        Specific topics covered in the journal include: Theoretical and applied optics, Delivery of patient care in optometry practice, 
        Refraction and correction of errors, Screening and preventative aspects of eye disease, Extended clinical roles for optometrists including shared care and provision of medications, 
        Teaching and training optometrists, International aspects of optometry, Business practice, Patient adherence, quality of life, satisfaction, Health economic evaluations.
        </p>
      </section>

      <div className="course-outline-container">
      <h1>Course Outline</h1>
      <table className="course-outline-table">
        <thead>
          <tr>
            <th>Paper</th>
            <th>Units</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>PAPER I: THEORY OF OPHTHALMIC LENSES</td>
            <td>
              <ul>
                <li>UNIT I: Introduction to Ophthalmic Lenses</li>
                <li>UNIT II: Definition, Terminology, and Properties of Lens</li>
                <li>UNIT III: Manufacturing and Dispensing</li>
                <li>UNIT IV: Types and Prescription</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>PAPER II: SPECTACLE FRAMES</td>
            <td>
              <ul>
                <li>UNIT I: Introduction to Spectacle Frames</li>
                <li>UNIT II: Mode of Selection</li>
                <li>UNIT III: Frame Selection</li>
                <li>UNIT IV: Frame Measurements and Marking</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>PAPER III: SPECIAL MEASUREMENTS FOR FITTING SPECIAL LENSES</td>
            <td>
              <ul>
                <li>UNIT I: IPD Measurement</li>
                <li>UNIT II: Markings and Adjustments</li>
                <li>UNIT III: Special Type of Spectacles</li>
                <li>UNIT IV: Special Type of Lenses</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td>
              PAPER IV: SAFETY STANDARDS FOR SPECTACLES AND PROFESSIONAL CONDUCT AND COMMUNICATION IN OPHTHALMIC DISPENSING
            </td>
            <td>
              <ul>
                <li>UNIT I: Spectacle Fitting Strategies</li>
                <li>UNIT II: Safety Glasses</li>
                <li>UNIT III: Occupational Dispensing</li>
                <li>UNIT IV: Safety Gadgets</li>
                <li>UNIT V: Troubleshooting</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



  <div className="diploma-optometry-container">
              <button
                className="btn arrow-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#courseDetailsFifth"
                aria-expanded="false"
                aria-controls="courseDetails"
               >
                Fellowship in Ocular motility and Binocular Vision
                <span className="arrow-icon">&#xf0d7;</span>
              </button>

  {/* Collapsible Content */}
  <div className="collapse" id="courseDetailsFifth">
          <section className="section">
          <h2 className="diploma-title">Fellowship in Ocular motility and Binocular Vision</h2>
          <p>Strabismus is diagnosed during an eye examination and variety of tests can help to detect strabismus. This fellowship is characterized by a broad exposure to clinical material and problem situations and can be tailored somewhat to fit special needs or interests of the optometrist.</p>
          </section>

          <section className="section">
            <h2>Eligibility</h2>
            <p>Fellowship is open to the optometrists who are completed 4 year Degree or 2 year Diploma in Optometry</p>
          </section>

          <section className="section">
            <h2>Duration</h2>
            <p>Duration    : 01 Year</p>
            <p>Admission   : Jan and June</p>
          </section>
          <section className="section">
            <h2>For a Batch</h2>
            <p> 10 Seats</p>
          </section>
      
          <section className="section">
            <h2>About this Course</h2>
            <p>
            Strabismus is a common disorder of ocular alignment that affects 2–4% of children. It is commonly referred to as a ‘squint’ or ‘lazy eye’. The most debilitating consequence of untreated strabismus is the development of amblyopia (permanent loss of best corrected visual acuity in a structurally healthy eye). Early detection and treatment improves vision outcomes and psychosocial wellbeing for children with strabismus. Nonetheless, many cases of strabismus go unrecognised.
            Strabismus management is to achieve good visual acuity in each eye, restore normal ocular alignment (as near as possible, which may be a small under or over correction) and maximize the potential for sensory cooperation between the two eyes (the development of binocular single vision, which includes 3D vision, or stereopsis).
            The main objective of this fellowship program is to provide a comprehensive experience in all aspects of strabismus management.
            The course is divided into two parts: Online Course and Hands on training. After successful completion of the online course and Hands on training, candidates must complete an online assessment test for each unit, comprising multiple choices and an onsite examination of the subject at the end of the academic year. A 60% pass rate is required.
            </p>
          </section>

          <div className="course-outline-container">
      <h1>Course Outline</h1>
      <table className="course-outline-table">
        <thead>
          <tr>
            <th>No :</th>
            <th>Topic</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Review of pupils</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Models of oculomotor control</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Accommodation</td>
          </tr>
          <tr>
            <td>4</td>
            <td>Dynamic aspects of accommodation</td>
          </tr>
          <tr>
            <td>5</td>
            <td>Introduction to eye movements</td>
          </tr>
          <tr>
            <td>6</td>
            <td>Assessment of extraocular muscles</td>
          </tr>
          <tr>
            <td>7</td>
            <td>Abnormal fixational eye movements</td>
          </tr>
          <tr>
            <td>8</td>
            <td>Saccades</td>
          </tr>
          <tr>
            <td>9</td>
            <td>Pursuits</td>
          </tr>
          <tr>
            <td>10</td>
            <td>Vestibular ocular reflex and optokinetic nystagmus</td>
          </tr>
          <tr>
            <td>11</td>
            <td>Nystagmus</td>
          </tr>
          <tr>
            <td>12</td>
            <td>Reading movements</td>
          </tr>
          <tr>
            <td>13</td>
            <td>Evaluation of eye movements</td>
          </tr>
          <tr>
            <td>14</td>
            <td>Introduction to binocular vision</td>
          </tr>
          <tr>
            <td>15</td>
            <td>Visual direction</td>
          </tr>
          <tr>
            <td>16</td>
            <td>Hering’s laws of crossed and uncrossed disparity</td>
          </tr>
          <tr>
            <td>17</td>
            <td>Motor fusion and vergence eye movements</td>
          </tr>
          <tr>
            <td>18</td>
            <td>Combined vergence, sensory fusion and the horopter</td>
          </tr>
          <tr>
            <td>19</td>
            <td>The empirical horopter</td>
          </tr>
          <tr>
            <td>20</td>
            <td>Introduction to fixation disparity</td>
          </tr>
          <tr>
            <td>21</td>
            <td>Measuring fixation disparity</td>
          </tr>
          <tr>
            <td>22</td>
            <td>Fixation disparity types</td>
          </tr>
          <tr>
            <td>23</td>
            <td>Binocular summation</td>
          </tr>
          <tr>
            <td>24</td>
            <td>Ocular dominance</td>
          </tr>
          <tr>
            <td>25</td>
            <td>Depth perception</td>
          </tr>
          <tr>
            <td>26</td>
            <td>Stereopsis 1</td>
          </tr>
          <tr>
            <td>27</td>
            <td>Stereopsis 2</td>
          </tr>
          <tr>
            <td>28</td>
            <td>Stereoscopic phenomena and stereograms</td>
          </tr>
          <tr>
            <td>29</td>
            <td>Rivalry and suppression</td>
          </tr>
          <tr>
            <td>30</td>
            <td>Aneiseikonia 1</td>
          </tr>
          <tr>
            <td>31</td>
            <td>Aneiseikonia 2</td>
          </tr>
          <tr>
            <td>32</td>
            <td>Neurophysiology of binocular vision</td>
          </tr>
          <tr>
            <td>33</td>
            <td>Normal binocular development</td>
          </tr>
          <tr>
            <td>34</td>
            <td>Amblyopia</td>
          </tr>
          <tr>
            <td>35</td>
            <td>Eccentric fixation</td>
          </tr>
          <tr>
            <td>36</td>
            <td>Anomalous retinal correspondence</td>
          </tr>
          <tr>
            <td>37</td>
            <td>Miscellaneous topics</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>





  <div className="diploma-optometry-container">
              <button
                className="btn arrow-btn"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#courseDetailsSixth"
                aria-expanded="false"
                aria-controls="courseDetails"
                >
                Fellowship in Contact Lens Dispensing
                <span className="arrow-icon">&#xf0d7;</span>
              </button>

  {/* Collapsible Content */}
  <div className="collapse" id="courseDetailsSixth">
          <section className="section">
          <h2 className="diploma-title">Fellowship in Contact Lens Dispensing</h2>
          <p>With so many contact lens materials, parameters and modalities available today, it is important that eye care practitioner must take a systematic approach to patient training during the initial contact lens evaluation.</p>
          </section>

          <section className="section">
            <h2>Eligibility</h2>
            <p>Fellowship is open to the optometrists who are completed 4 year Degree or 2 year Diploma in Optometry</p>
          </section>

          <section className="section">
            <h2>Duration</h2>
            <p>Duration    : 06 months</p>
            <p>Admission   : Jan and June</p>
          </section>
          <section className="section">
            <h2>For a Batch</h2>
            <p> 20 Seats</p>
          </section>
      
          <section className="section">
            <h2>About this Course</h2>
            <p>
            With so many contact lens materials, parameters and modalities available today, it is important for the eye care practitioner to match the proper lens to each individual patient. We must take a systematic approach to patient training during the initial contact lens evaluation. Ensuring that patients are comfortable with handling their lenses.
            Developed to meet the needs of practicing optometrists, the curriculum has been designed to enhance understanding of contact lens practice and enable graduates to increase their competency through theory and the development of appropriate skills. An expert team of presenters will deliver a range of topics including current information on contact lenses, lens fitting and special lenses.
            This qualification builds on the baseline knowledge and skills of contact lens practice of qualified optometrists. It covers a range of topics including an ability to detect, assess and manage the impact of contact lens complications on the anterior eye, RGP fitting, orthokeratology, myopia control, early keratoconus, presbyopia, toric lens fitting etc.
            The course is divided into two parts: Online Course and Hands on training.
            After successful completion of the online course and Hands on training, candidates must complete an online assessment test for each unit, comprising multiple choices and an onsite examination of the subject at the end of the academic year. A 60% pass rate is required.
            </p>
          </section>

     
        <section className="section">
        <h2>Objectives</h2>
        <p>
        With so many contact lens materials, parameters and modalities available today, 
        it is important for the eye care practitioner to match the proper lens to each individual patient. 
        we must take a systematic approach to patient training during the initial contact lens evaluation. 
        Ensuring that patients are comfortable with handling their lenses.</p>
      </section>

      
    <div className="course-outline-container">
      <h1>Course Outline</h1>
      <table className="course-outline-table">
        <thead>
          <tr>
            <th>Module</th>
            <th>Topic</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>Module 1</b></td>
            <td>The Basics of Contact Lenses</td>
          </tr>
          <tr>
            <td>1.1</td>
            <td>Anatomy and Physiology of the Anterior Eye</td>
          </tr>
          <tr>
            <td>1.2</td>
            <td>History of Contact Lenses</td>
          </tr>
          <tr>
            <td>1.3</td>
            <td>Optics of Contact Lenses</td>
          </tr>
          <tr>
            <td>1.4</td>
            <td>Contact Lens Designs</td>
          </tr>
          <tr>
            <td>1.5</td>
            <td>Contact Lens Fabrication</td>
          </tr>
          <tr>
            <td>1.6</td>
            <td>Corneal Oxygenation in Contact Lens Wear</td>
          </tr>
          <tr>
            <td><b>Module 2</b></td>
            <td>Contact Lens Fitting</td>
          </tr>
          <tr>
            <td>2.1</td>
            <td>Examining the Prospective Contact Lens Patient</td>
          </tr>
          <tr>
            <td>2.2</td>
            <td>Selecting Lens Type, Wear Mode, and Replacement Rate</td>
          </tr>
          <tr>
            <td>2.3</td>
            <td>Fitting Spherical GP Contact Lenses</td>
          </tr>
          <tr>
            <td>2.4</td>
            <td>Fitting Spherical Soft Contact Lenses</td>
          </tr>
          <tr>
            <td>2.5</td>
            <td>Correcting Astigmatism with Contact Lenses</td>
          </tr>
          <tr>
            <td>2.6</td>
            <td>Fitting Silicone Hydrogel Contact Lenses</td>
          </tr>
          <tr>
            <td>2.7</td>
            <td>The Dispensing Visit and After Care</td>
          </tr>
          <tr>
            <td>2.8</td>
            <td>Contact Lenses for Sports</td>
          </tr>
          <tr>
            <td>2.9</td>
            <td>Presbyopic Contact Lens Options</td>
          </tr>
          <tr>
            <td><b>Module 3</b></td>
            <td>Contact Lens Care</td>
          </tr>
          <tr>
            <td>3.1</td>
            <td>Contact Lens Contamination & Lens Deposits</td>
          </tr>
          <tr>
            <td>3.2</td>
            <td>Contact Lens Care and Contact Lens Care Products</td>
          </tr>
          <tr>
            <td>3.3</td>
            <td>Rigid Contact Lens Care</td>
          </tr>
          <tr>
            <td>3.4</td>
            <td>Silicone Hydrogel and Hydrogel Contact Lens Care</td>
          </tr>
          <tr>
            <td><b>Module 4</b></td>
            <td>Complications</td>
          </tr>
          <tr>
            <td>4.1</td>
            <td>Defending the Ocular Surface in Contact Lens Wear</td>
          </tr>
          <tr>
            <td>4.2</td>
            <td>Rigid Contact Lens Complications</td>
          </tr>
          <tr>
            <td>4.3</td>
            <td>Soft Contact Lens Complications</td>
          </tr>
          <tr>
            <td>4.4</td>
            <td>Dry Eye and Contact Lenses</td>
          </tr>
          <tr>
            <td><b>Module 5</b></td>
            <td>Advanced Contact Lens Practice</td>
          </tr>
          <tr>
            <td>5.1</td>
            <td>Children and Contact Lenses</td>
          </tr>
          <tr>
            <td>5.2</td>
            <td>Fitting Scleral and Miniscleral Contact Lenses</td>
          </tr>
          <tr>
            <td>5.3</td>
            <td>Myopia Control and Orthokeratology</td>
          </tr>
          <tr>
            <td>5.4</td>
            <td>Contact Lenses for Keratoconus</td>
          </tr>
          <tr>
            <td>5.5</td>
            <td>Special Applications of Contact Lenses</td>
          </tr>
          <tr>
            <td>5.6</td>
            <td>Advanced Techniques and Instrumentation</td>
          </tr>
          <tr>
            <td>5.7</td>
            <td>Business Aspects of Contact Lens Practice</td>
          </tr>
          <tr>
            <td><b>Module 6</b></td>
            <td>Myopia and its Management</td>
          </tr>
          <tr>
            <td>6.1</td>
            <td>Emmetropization in the Context of Myopia</td>
          </tr>
          <tr>
            <td>6.2</td>
            <td>Methods of Controlling Myopia</td>
          </tr>
          <tr>
            <td>6.3</td>
            <td>Contact Lenses for Myopia Control</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>





      <div className="how-to-apply-container">
      <h2 className="section-title">How to Apply</h2>
      <div className="steps-container">
        <div className="step">
          <div className="circle orange">
          <span>&#x270F;</span>
          </div>
          <h3 className="step-title">REGISTRATION</h3>
          <p>
            <a
              href="/shorttermcourseregistration"
              style={{ textDecoration: 'none' }}
            >
              To Register
            </a>
          </p>
        </div>
                {/* <div className="step">
              <div className="circle green">
                <span>&#128441;</span>
              </div>
              <h3 className="step-title">Guidelines</h3>
              <a href="/Guidelines.pdf" download className="download-button" style={{ textDecoration: 'none' }}>
                Download Guidelines
              </a>
              <div className="download-pdf"></div>

                </div> */}
      </div>
      <div className="contact-us">
        <a href="/contactus" className="contact-button text-decoration-none">
          Contact Us <span>&#x2192;</span>
        </a>
      </div>
    </div>
    </div>
  )
}

export default FellowshipCourse